module.exports = __webpack_public_path__ + "static/media/ricette.9921aa5b.jpg";